import React from 'react';
import { Column, Row } from 'components/Layout/Grid';
import Text from 'components/Text';
import Input from 'components/Input';
import { Tooltip } from 'react-tooltip';
import imgToolTipRI from 'img/icon-duvida.svg';
import { IRIProduct } from './interface';
import './styles.scss';

const RIProduct: React.FC<IRIProduct> = (props) => {
  const { productRI, setProductRI, legalPerson } = props;

  const onChangeRI = (e: any) => {
    setProductRI(e);
  };

  const msgRi = 'Registro interno que consta no carretel do produto (dentro) para rastreabilidade juntamente com o número do lote';

  return (
    <Row className={`flex-md-column mt-3 ${legalPerson === 2 && 'ml-4'} ml-md-0`}>
      <Column
        className={'flex-1 max-w-md-100 mt-md-2'}
      >
        <Row className="align-center">
          <Text className="mr-2 mb-2 color-blue-gray" size={12}>
            RI do produto
          </Text>
          <img
            src={imgToolTipRI}
            data-tooltip-content={msgRi}
            data-tooltip-place={'top'}
            className="RIToolTip mb-2"
          />
        </Row>
        <Input
          id="productRI"
          stateName="productRI"
          onChange={(e: any) => onChangeRI(e.target.value)}
          required={false}
          name="RI do produto"
          className="w-100"
          type="text"
          value={productRI}
          placeholder="Descrição"
          disabled={false}
        />
        {msgRi && <Tooltip variant="light" />}
      </Column>
    </Row>
  );
};

export default RIProduct;
